import { Timestamp } from "@bufbuild/protobuf";
import { createRouterTransport } from "@connectrpc/connect";
import { AccountService } from "schema/gen/es/chiikipoint/storeconsole/v2/account_service_connect";
import {
  type GetTenantRequest,
  GetTenantResponse,
  type LoginRequest,
  LoginResponse,
} from "schema/gen/es/chiikipoint/storeconsole/v2/account_service_pb";
import { StoreService } from "schema/gen/es/chiikipoint/storeconsole/v2/service_connect";
import {
  type GetMyStoreRequest,
  GetMyStoreResponse,
  type GetTransactionsRequest,
  GetTransactionsResponse,
  type RefundRequest,
  RefundResponse,
} from "schema/gen/es/chiikipoint/storeconsole/v2/service_pb";
import {
  StoreWithCompany,
  Tenant,
  TransactionGroup,
  Transaction_Type,
} from "schema/gen/es/chiikipoint/model/v2/model_pb";

export const mockGetTenant = async (
  _req: GetTenantRequest,
): Promise<GetTenantResponse> => {
  const tenant = new Tenant({
    id: "550e8400-e29b-41d4-a716-446655440000",
    name: "デモ地域ポイント",
    slug: "demo",
    serviceId: "b43596db-9481-432f-ae7f-d4a89de9af7c",
    contact: "0120-1234-5678",
    iconUrl: "/misc/icons/demo.png",
  });

  return new GetTenantResponse({
    tenant,
  });
};

export const mockLogin = async (_req: LoginRequest): Promise<LoginResponse> => {
  return new LoginResponse({
    token:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjQ4NDIyOTc2MDAsInN1YiI6Im1vY2stc3RvcmUtdXNlciIsImlhdCI6MTcxMDI5NzYwMH0.UWk8m4wZzJ5O6s8RcT2uJ0uLfNEPoPFcAckU4iRnt-Y",
  });
};

export const mockGetMyStore = async (
  _req: GetMyStoreRequest,
): Promise<GetMyStoreResponse> => {
  const storeWithCompany = new StoreWithCompany({
    company: {
      id: "67e55044-10b1-426f-9247-bb680e5fe0c8",
      name: "みやポマート",
      ownerName: "日本橋 太郎",
      address: "宮城県仙台市青葉区一番町１丁目３−２",
      contact: "022-123-4567",
      iconUrl: "/misc/default-store-icon.png",
      bankName: "日本橋銀行",
      bankBranchName: "日本橋支店",
      bankAccountType: "普通",
      bankAccountNumber: "1234567",
      bankAccountHolderName: "日本橋 太郎",
    },
    store: {
      id: "RYks43cB",
      slug: "RYks43cB",
      companyId: "67e55044-10b1-426f-9247-bb680e5fe0c8",
      name: "みやぎ生協",
      fullAddress: "宮城県仙台市青葉区一番町１丁目３−２",
      city: "宮城県仙台市青葉区",
      category: "コンビニ",
      iconUrl: "/misc/default-store-icon.png",
      location: {
        latitude: 38.25783587179756,
        longitude: 140.87284595831724,
      },
    },
  });

  return new GetMyStoreResponse({
    storeWithCompany,
  });
};

const storeSummary = {
  id: "RYks43cB",
  name: "みやぎ生協",
  companyId: "67e55044-10b1-426f-9247-bb680e5fe0c8",
  iconUrl: "/misc/default-store-icon.png",
  category: "コンビニ",
  fullAddress: "宮城県仙台市青葉区一番町１丁目３−２",
  slug: "RYks43cB",
};

const createStoreTransactionGroups = () => {
  return [
    new TransactionGroup({
      id: "store-group-payment",
      transactionDetails: [
        {
          transaction: {
            id: "store-payment-1",
            groupId: "store-group-payment",
            userId: "store-user-1",
            type: Transaction_Type.PAYMENT,
            amount: BigInt(-1200),
            qrId: "STORE-QR-1",
            reason: "支払い",
            createdAt: Timestamp.fromDate(new Date("2024-02-16T10:23:30.000Z")),
          },
          store: storeSummary,
          user: {
            gender: 1,
            ageGroup: BigInt(20),
          },
        },
      ],
    }),
    new TransactionGroup({
      id: "store-group-refund",
      transactionDetails: [
        {
          transaction: {
            id: "store-payment-2",
            groupId: "store-group-refund",
            userId: "store-user-2",
            type: Transaction_Type.PAYMENT,
            amount: BigInt(-980),
            qrId: "STORE-QR-2",
            reason: "支払い",
            createdAt: Timestamp.fromDate(new Date("2024-02-15T09:10:00.000Z")),
          },
          store: storeSummary,
          user: {
            gender: 2,
            ageGroup: BigInt(40),
          },
        },
        {
          transaction: {
            id: "store-refund-2",
            groupId: "store-group-refund",
            userId: "store-user-2",
            type: Transaction_Type.REFUND,
            amount: BigInt(980),
            reason: "返金",
            createdAt: Timestamp.fromDate(new Date("2024-02-15T09:15:00.000Z")),
          },
          store: storeSummary,
          user: {
            gender: 2,
            ageGroup: BigInt(40),
          },
        },
      ],
    }),
    new TransactionGroup({
      id: "store-group-redeem",
      transactionDetails: [
        {
          transaction: {
            id: "store-payment-3",
            groupId: "store-group-redeem",
            userId: "store-user-3",
            type: Transaction_Type.PAYMENT,
            amount: BigInt(-560),
            qrId: "STORE-QR-3",
            reason: "支払い",
            createdAt: Timestamp.fromDate(new Date("2024-02-14T14:20:00.000Z")),
          },
          store: storeSummary,
          user: {
            gender: 0,
            ageGroup: BigInt(50),
          },
        },
        {
          transaction: {
            id: "store-redeem-3",
            groupId: "store-group-redeem",
            userId: "store-user-3",
            type: Transaction_Type.REDEEM,
            amount: BigInt(560),
            reason: "締め",
            createdAt: Timestamp.fromDate(new Date("2024-02-14T16:00:00.000Z")),
          },
          store: storeSummary,
          user: {
            gender: 0,
            ageGroup: BigInt(50),
          },
        },
      ],
    }),
  ];
};

let storeTransactionGroupsState = createStoreTransactionGroups();

export const mockGetTransactions = async (
  _req: GetTransactionsRequest,
): Promise<GetTransactionsResponse> => {
  return new GetTransactionsResponse({
    transactionGroups: storeTransactionGroupsState,
  });
};

export const mockRefund = async (
  req: RefundRequest,
): Promise<RefundResponse> => {
  const currentGroup = storeTransactionGroupsState.find(
    (group) => group.id === req.transactionGroupId,
  );

  if (!currentGroup) {
    return new RefundResponse({});
  }

  const hasRefund = currentGroup.transactionDetails.some(
    (detail) => detail.transaction?.type === Transaction_Type.REFUND,
  );
  if (hasRefund) {
    return new RefundResponse({
      transactionGroup: currentGroup,
    });
  }

  const paymentDetail = currentGroup.transactionDetails.find(
    (detail) => detail.transaction?.type === Transaction_Type.PAYMENT,
  );
  if (!paymentDetail?.transaction) {
    return new RefundResponse({});
  }

  let paymentAmount = BigInt(0);
  for (const detail of currentGroup.transactionDetails) {
    if (detail.transaction?.type !== Transaction_Type.PAYMENT) {
      continue;
    }
    const amount = detail.transaction.amount ?? BigInt(0);
    paymentAmount += amount < BigInt(0) ? -amount : amount;
  }

  const refundedGroup = new TransactionGroup({
    id: currentGroup.id,
    transactionDetails: [
      ...currentGroup.transactionDetails,
      {
        transaction: {
          id: `refund-${currentGroup.id}`,
          groupId: currentGroup.id,
          userId: paymentDetail.transaction.userId,
          type: Transaction_Type.REFUND,
          amount: paymentAmount,
          createdAt: Timestamp.fromDate(new Date()),
          reason: req.reason,
          refundedGroupId: currentGroup.id,
          refunderStoreStaffId: "mock-store-staff",
        },
        store: paymentDetail.store,
        user: paymentDetail.user,
      },
    ],
  });

  storeTransactionGroupsState = storeTransactionGroupsState.map((group) =>
    group.id === currentGroup.id ? refundedGroup : group,
  );

  return new RefundResponse({
    transactionGroup: refundedGroup,
  });
};

export const storeAccountServiceMockTransport = createRouterTransport(
  ({ service }) => {
    service(AccountService, {
      getTenant: mockGetTenant,
      login: mockLogin,
    });
  },
);

export const storeServiceMockTransport = createRouterTransport(({ service }) => {
  service(StoreService, {
    getMyStore: mockGetMyStore,
    getTransactions: mockGetTransactions,
    refund: mockRefund,
  });
});
